import {OfferType} from "../../offer/types/OfferType";
import {searchFilters} from "../constants/search_filters";
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";

export const getSearchFiltersByOfferType = (offerType?: OfferType | "notification"): ISearchFilters<ISearchFiltersFormValues> => {
    return searchFilters[offerType || "default"];
};
import {OfferType} from "../../offer/types/OfferType";
import {searchFilters} from "../constants/search_filters";
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";

export const getSearchFiltersByOfferType = (offerType?: OfferType | "notification"): ISearchFilters<ISearchFiltersFormValues> => {
    return searchFilters[offerType || "default"];
};
